import { BusinessAnalyticsLayout } from "../layouts/BusinessAnalyticsLayout";
import { BusinessAnalyticsInstance } from "../utils/businessAnalyticsClass";
import { Dashboard } from "./DashboardPage";
import { Row } from "react-bootstrap";

export const ProductAnalyticsPage = () => {
    const initializeBusinessAnalytics = async () => {
        await BusinessAnalyticsInstance.initialize();
    };

    return (
        <Dashboard header="Product Analytics">
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                    flexDirection: "column",
                }}
            >
                <h2>Coming Soon!</h2>
            </div>
        </Dashboard>
    );
};
